import React from 'react';
import { Box } from '@mui/material';
import { AttachFile } from '@mui/icons-material';
import { useMsal, useAccount } from '@azure/msal-react';
import { SectionHeader, SectionPaper } from '../../../../common/components/styled-ui-elements';
import { DocumentUploadsControl } from '../../../../common/components/DocumentUploads';
import { useAppSelector } from '../../../../../app/hooks';
import {
  useListAssetDocumentsQuery,
  useUploadAssetDocumentMutation,
  useDownloadAssetDocumentMutation,
  useDeleteAssetDocumentMutation
} from '../../../../../services/AssetService/assetApi';

/**
 * DocumentUploadsSection - thin Asset-specific wrapper around the shared DocumentUploadsControl.
 * Wires Asset document hooks; only rendered on Edit Asset, once an asset id exists.
 */
export const DocumentUploadsSection: React.FC = () => {
  const assetId = useAppSelector(state => state.asset.currentAsset?.id) || '';

  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const currentUserName = account?.name || '';

  const { data: documents, isLoading, isError, error } = useListAssetDocumentsQuery(assetId, {
    skip: !assetId
  });
  const [uploadAssetDocument] = useUploadAssetDocumentMutation();
  const [downloadAssetDocument] = useDownloadAssetDocumentMutation();
  const [deleteAssetDocument] = useDeleteAssetDocumentMutation();

  return (
    <Box>
      <SectionHeader
        icon={<AttachFile sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Documents"
      />
      <SectionPaper>
        <DocumentUploadsControl
          entityId={assetId}
          documents={documents}
          isLoading={isLoading}
          isError={isError}
          error={error}
          currentUserName={currentUserName}
          defaultDocumentType="General"
          onUpload={(file, documentType) => uploadAssetDocument({ assetId, file, documentType }).unwrap().then(() => undefined)}
          onDownload={(documentId) => downloadAssetDocument({ assetId, documentId }).unwrap()}
          onDelete={(documentId) => deleteAssetDocument({ assetId, documentId }).unwrap()}
        />
      </SectionPaper>
    </Box>
  );
};

export default DocumentUploadsSection;
